// components/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const ProtectedRoute = ({ children }) => {
    const isLoggedIn = Cookies.get("isLoggedIn") === "true";
    const location = useLocation();

    return isLoggedIn ? (
        children
    ) : (
        <Navigate to="/" replace state={{ from: location }} />
    );
};

export default ProtectedRoute;
